"use strict";function launchApp$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.launchApp$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="device.launcher.launchApp";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.4.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.4.0"},_a)),exports.launchApp$=launchApp$,exports.default=launchApp$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/device/launcher/launchApp.js
// module id = 1063
// module chunks = 106